<!-- src/views/WidgetView.vue -->
<template>
  <div class="widget-page">
    <div 
      class="supplyvet-widget" 
      :class="widgetPositionClass"
      id="supplyvet-widget-container"
    >
      <a 
        :href="widgetLink" 
        target="_blank" 
        class="supplyvet-widget-content"
      >
        <img 
          :src="logo"
          alt="Supplyvet"
          class="widget-logo"
        >
      </a>
      <div class="supplyvet-widget-hover">
        <a :href="widgetLink" target="_blank">
          <p>POUR COMMANDER <br><strong>CLIQUEZ ICI !</strong></p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import logo from "../assets/images/widget_delegue.png";
export default {
  name: "WidgetView",
  data() {
    return {
      token: "",
      position: "basDroite", // Default position
      widgetLink: "#",
      logo
    };
  },
  computed: {
    widgetPositionClass() {
      const positionMap = {
        "hautGauche": "top-left",
        "hautDroite": "top-right",
        "basGauche": "bottom-left",
        "basDroite": "bottom-right"
      };
      return positionMap[this.position] || "bottom-right";
    }
  },
  mounted() {
    // Extract parameters from URL
    const urlParams = new URLSearchParams(window.location.search);
    this.token = urlParams.get('token') || "";
    this.position = urlParams.get('position') || "basDroite";
    
    // Set the widget link with the token
    if (this.token) {
      const baseUrl = "/login-proprietaire" || "#";
      this.widgetLink = baseUrl
    }
  }
};
</script>

<style scoped>
.widget-page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.supplyvet-widget {
  position: fixed;
  width: 200px;
  z-index: 9999;
  transition: all 0.3s ease;
}

.supplyvet-widget.top-left {
  top: 20px;
  left: 20px;
}

.supplyvet-widget.top-right {
  top: 20px;
  right: 20px;
}

.supplyvet-widget.bottom-left {
  bottom: 20px;
  left: 20px;
}

.supplyvet-widget.bottom-right {
  bottom: 20px;
  right: 20px;
}

.supplyvet-widget-content {
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.18);
  border-radius: 14px;
  opacity: 1;
  cursor: pointer;
  padding: 20px;
  background: #fff;
  display: block;
  width: 100%;
  overflow: hidden;
  position: relative;
  transition: transform 0.3s ease;
  text-decoration: none;
  display: block;
}

.supplyvet-widget-content:hover {
  transform: scale(1.05);
}

.widget-logo {
  width: 100%;
  height: auto;
  display: block;
}

.supplyvet-widget-hover {
  background-color: #1e347d;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  transition: opacity 0.3s ease, transform 0.3s ease;
  width: 100%;
  border-radius: 14px;
  padding: 12px 0 0 0;
  opacity: 0;
  transform: translateY(10px);
  box-sizing: border-box;
}

.supplyvet-widget:hover .supplyvet-widget-hover {
  opacity: 1;
  transform: translateY(0);
}

.supplyvet-widget-hover a {
  color: #e9ecef;
  text-decoration: none;
  text-align: center;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.supplyvet-widget-hover p {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
}

.supplyvet-widget-hover strong {
  display: block;
  margin-top: 5px;
  font-size: 16px;
}
</style>